import React from 'react';
import PropTypes from 'prop-types';

import websitePage, { headerTypes } from 'hoc/websitePage/websitePage';

import SectionForm from './patterns/SectionForm/SectionForm';
import SectionTransparency from './patterns/SectionTransparency/SectionTransparency';
import SectionSimulate from './patterns/SectionSimulate/SectionSimulate';
import SectionManage from './patterns/SectionManage/SectionManage';
import SectionLastMessage from './patterns/SectionLastMessage/SectionLastMessage';
import SectionFAQ from './patterns/SectionFAQ/SectionFAQ';
import SectionKnowMore from './patterns/SectionKnowMore/SectionKnowMore';

function Lending({ onFormVisibilityChange }) {
  return (
    <>
      <SectionForm onFormVisibilityChange={onFormVisibilityChange} />
      <SectionTransparency />
      <SectionSimulate />
      <SectionManage />
      <SectionLastMessage />
      <SectionFAQ />
      <SectionKnowMore />
    </>
  );
}

Lending.propTypes = {
  onFormVisibilityChange: PropTypes.func.isRequired,
};

export default websitePage({
  routeKey: 'LENDING',
  header: headerTypes.PRODUCT_PAGE,
})(Lending);
